import { createRouter,createWebHashHistory,createWebHistory} from "vue-router";


const routes = [
  {
    path: '/login',
    name:'登录',
    component: () => import('../viwes/Login/Login'),
    meta: {requireAuth: true},
    children: []
   }, 

   {
        path: '/',
        name:'',
        component: () => import('../viwes/Index/Index'),
        meta: {requireAuth: true},
        children: [
          // 用户管理
          {
            path: 'user/list',
            name:'用户列表',
            component: () => import('../viwes/User/UserList'),
            meta: {requireAuth: true},
            children: []
          },
          // 订单管理
          {
            path: 'orders/list',
            name:'订单列表',
            component: () => import('../viwes/Orders/OrdersList'),
            meta: {requireAuth: true},
            children: []
          },
          // {
          //   path: 'orders/refund',
          //   name:'退款记录',
          //   component: () => import('../viwes/Orders/OrdersRefund'),
          //   meta: {requireAuth: true},
          //   children: []
          // },
          {
            path: 'orders/orderpay',
            name:'审核付款订单',
            component: () => import('../viwes/Orders/OrderPay'),
            meta: {requireAuth: true},
            children: []
          },
          // 商品管理
          {
            path: 'goods/list',
            name:'商品列表',
            component: () => import('../viwes/Goods/GoodsList'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'goods/category',
            name:'商品分类',
            component: () => import('../viwes/Goods/GoodsCategory'),
            meta: {requireAuth: true},
            children: []
          },
          // 账单管理
          {
            path: 'bill/list',
            name:'账单明细',
            component: () => import('../viwes/Bill/BillList'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'bill/moon_pools',
            name:'月池记录',
            component: () => import('../viwes/Bill/MoonPools'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'bill/withdraw',
            name:'提现管理',
            component: () => import('../viwes/Bill/Withdraw'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'bill/silverreview',
            name:'银龟购买审核',
            component: () => import('../viwes/Bill/SilverTurtleReview'),
            meta: {requireAuth: true},
            children: []
          },
          // 营销管理
          {
            path: 'carousel/list',
            name:'轮播图',
            component: () => import('../viwes/Carousel/CarouselList'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'other/distribution',
            name:'推销配置',
            component: () => import('../viwes/Other/Distribution'),
            meta: {requireAuth: true},
            children: []
          },
          // 系统管理
          {
            path: 'other/district_agent',
            name:'区域代理',
            component: () => import('../viwes/Other/DistrictAgent'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'other/protocol',
            name:'用户协议',
            component: () => import('../viwes/Other/Protocol'),
            meta: {requireAuth: true},
            children: []
          },
          {
            path: 'other/customer',
            name:'客服配置',
            component: () => import('../viwes/Other/Customer'),
            meta: {requireAuth: true},
            children: []
          },
           {
            path: 'other/payconfig',
            name:'支付配置',
            component: () => import('../viwes/Other/PayConfig'),
            meta: {requireAuth: true},
            children: []
          },
         
         
        ]
     }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router;
